import { useState } from 'react';

const ITEMS_PER_PAGE = 5;

export interface RepoFilterState {
  selectedOrganization: string;
  selectedVisibility: string;
  selectedLanguage: string;
  selectedScanStatus: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  currentPage: number;
  itemsPerPage: number;
  setSelectedOrganization: (v: string) => void;
  setSelectedVisibility: (v: string) => void;
  setSelectedLanguage: (v: string) => void;
  setSelectedScanStatus: (v: string) => void;
  setSortBy: (v: string) => void;
  setSortOrder: (v: 'asc' | 'desc' | ((prev: 'asc' | 'desc') => 'asc' | 'desc')) => void;
  setCurrentPage: (v: number | ((prev: number) => number)) => void;
  resetFilters: () => void;
}

export function useRepoFilters(): RepoFilterState {
  const [selectedOrganization, setSelectedOrganization] = useState<string>('');
  const [selectedVisibility, setSelectedVisibility] = useState<string>('');
  const [sortBy, setSortBy] = useState<string>('name');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [selectedScanStatus, setSelectedScanStatus] = useState<string>('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = ITEMS_PER_PAGE;

  const resetFilters = () => {
    setSelectedOrganization('');
    setSelectedVisibility('');
    setSelectedLanguage('');
    setSelectedScanStatus('');
    setSortBy('name');
    setSortOrder('asc');
    setCurrentPage(1);
  };

  return {
    selectedOrganization,
    selectedVisibility,
    selectedLanguage,
    selectedScanStatus,
    sortBy,
    sortOrder,
    currentPage,
    itemsPerPage,
    setSelectedOrganization,
    setSelectedVisibility,
    setSelectedLanguage,
    setSelectedScanStatus,
    setSortBy,
    setSortOrder,
    setCurrentPage,
    resetFilters,
  };
}
